export default {
  __html: `<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-width="2">
                <path d="M15.886 4.743C14.429 2.57 11.77 1 9 1 4.571 1 1 4.571 1 9s3.571 8 8 8c4.314 0 7.857-3.429 8-7.714"/>
                <path stroke-linejoin="round" d="M12.429 5.571H17V1"/>
            </g>`
}
